import React, { useCallback } from "react";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";
import { getDeploymentVehicleLogDetailsFilter } from "../../services/deployment";
import { getColumnsData } from "./GroupDeploymentListColumns";
import { detailsTabsBoxStyle } from "../../services/Utils";
import OTAPagination from "../OTAPagination";

const GroupDeploymentList = (props = {}) => {
  let { deploymentId, groupId: paramGroupId } = useParams();
  const groupId = props?.groupId || paramGroupId;

  const getDeploymentLogFn = useCallback(
    ({ queryKey }) => {
      return getDeploymentVehicleLogDetailsFilter({
        queryKey: [...queryKey, deploymentId],
      });
    },
    [deploymentId]
  );

  const columns = getColumnsData();

  const extraFilters = groupId
    ? [
        {
          columnField: "vehicleGroupId",
          operatorValue: "equals",
          value: groupId,
        },
      ]
    : [];

  return (
    <Box
      {...detailsTabsBoxStyle}
      sx={{
        "& .MuiDataGrid-root": {
          minHeight: "unset !important",
        },
        "& .MuiDataGrid-main": {
          minHeight: "170px",
        },
        "& .MuiDataGrid-virtualScroller": {
          minHeight: "auto",
          paddingBottom: "40px !important",
        },
        width: "100%",
      }}
    >
      <OTAPagination
        tableTitle="Vehicles In Group Deployment"
        columns={columns}
        endpointFn={getDeploymentLogFn}
        queryName={`groupDeploymentVehicleLogs_${groupId}_${deploymentId}`}
        filterMode="server"
        sortByDefault="createdAt"
        getRowId={(row) => row?.deploymentLogId || row?.serialNo}
        exportCSV={true}
        extraFilters={extraFilters}
        autoHeight={true}
      />
    </Box>
  );
};

export default GroupDeploymentList;